import { useState } from "react";
import {
  BeaconTableColumns,
  SCBOneDevice,
  SCBOneDevicesTableSorting,
} from "../../api";
import { useSCBOneDevices } from "../../api/api.scb-one";
import { BeaconTableBase } from "../../components/BeaconTableBase";

interface SCBOneDevicesTableProps {
  currentUserIsSolutionOperator: boolean;
}

const useSorting = () => {
  const [sorting, setSorting] = useState<SCBOneDevicesTableSorting>({
    sortColumnId: undefined,
    sortOrderId: undefined,
  });

  const onSortingChange = (sorting: SCBOneDevicesTableSorting) => {
    setSorting(sorting as SCBOneDevicesTableSorting);
  };

  return { sorting, onSortingChange };
};

const useFiltering = () => {
  const [filter, setFilter] = useState<string>("");

  const onFiltering = (filter: string) => {
    /* 
      Debounce filter in BaconTableBase.tsx causes a race case condition (I believe), dude to this 
      setting a timeout of the same duration as the debounce in the BeaconTableBase.tsx
      Not a good solution, but it works for now.
     */
    setTimeout(() => {
      setFilter(filter);
    }, 300);
  };

  return { filter, onFiltering };
};

export function SCBOneDevicesTable({
  currentUserIsSolutionOperator,
}: SCBOneDevicesTableProps) {
  const { sorting, onSortingChange } = useSorting();
  const { filter, onFiltering } = useFiltering();
  const SCBOneDevices = useSCBOneDevices(undefined, filter, sorting);

  return (
    <BeaconTableBase<SCBOneDevice, SCBOneDevicesTableSorting>
      beaconData={SCBOneDevices}
      tableType="scb-one"
      visibleColumns={[
        BeaconTableColumns.Serial,
        BeaconTableColumns.Status,
        currentUserIsSolutionOperator
          ? BeaconTableColumns.OrganizationName
          : BeaconTableColumns.OmmitColumn,
        BeaconTableColumns.LastMessageReceivedAt,
        BeaconTableColumns.ConfigurationButton,
      ]}
      sortableColumns={[
        BeaconTableColumns.Serial,
        BeaconTableColumns.Status,
        currentUserIsSolutionOperator
          ? BeaconTableColumns.OrganizationName
          : BeaconTableColumns.OmmitColumn,
        BeaconTableColumns.LastMessageReceivedAt,
        BeaconTableColumns.ConfigurationButton,
      ]}
      showSorter={true}
      showBeaconFilter={true}
      onSort={onSortingChange}
      onFilter={onFiltering}
    />
  );
}
